__turbopack_context__.v({
  "icon": "xgrG2a_icon",
  "label": "xgrG2a_label",
});
